import { parseAsString, useQueryStates } from 'nuqs';
import { CheckoutModal } from './checkout-modal';

/** Abre o checkout quando a URL tem ?receber=<atendimento> ou ?assinatura=<assinatura>. */
export function CheckoutHost({ defaultBranchId }: { defaultBranchId: string | null }) {
  const [{ receber, assinatura }, set] = useQueryStates({ receber: parseAsString, assinatura: parseAsString }, { history: 'push' });
  if (!receber && !assinatura) return null;
  return (
    <CheckoutModal
      key={`${receber ?? ''}:${assinatura ?? ''}`}
      appointmentId={receber}
      subscriptionId={receber ? null : assinatura}
      defaultBranchId={defaultBranchId}
      onClose={() => void set({ receber: null, assinatura: null })}
    />
  );
}
